export const testimonialTranslations = {
  testimonial1Quote: {
    en: "Penang Gateway made my transition to student life in Penang incredibly smooth. Their visa guidance and accommodation services saved me so much time and stress!",
    zh: "槟城门户让我在槟城的学生生活过渡得非常顺利。他们的签证指导和住宿服务为我节省了大量时间和压力！"
  },
  testimonial2Quote: {
    en: "As a first-time visitor to Penang, I was overwhelmed with planning. The travel guides and local tips from Penang Gateway made my vacation perfect!",
    zh: "作为第一次来槟城的游客，我对规划感到不知所措。槟城门户的旅游指南和当地小贴士让我的假期非常完美！"
  },
  testimonial3Quote: {
    en: "The immigration information was spot on and up-to-date. I had no issues with my entry process thanks to the detailed guidance provided.",
    zh: "移民信息准确且最新。多亏了他们提供的详细指导，我的入境过程没有任何问题。"
  },
  internationalStudentRole: {
    en: "International Student",
    zh: "国际学生"
  },
  touristFromAustraliaRole: {
    en: "Tourist from Australia",
    zh: "来自澳大利亚的游客"
  },
  businessTravelerRole: {
    en: "Business Traveler",
    zh: "商务旅客"
  }
};
